

/* eslint-disable max-len */
export const colors = {
  red: '#DA4453',
  darkGray: '#3E3E3E',
  white: '#ffffff',
  black: '#000000'
}

export const fontSizes = {
  
    lg:{
      large: 47,
      regular: 30,
      small: 20,
    },
    md:{
      large: 25,
      regular: 16,
      small: 12,
    },
    sm:{
      large: 18,
      regular: 14,
      small: 10,
    },
}

export const fontFamily = {
  
  poppins: 'Poppins',
 
}

// export const breakpoints = {
//   xs: 0,
//   sm: 576,
//   md: 768,
//   lg: 992,
//   xl: 1200
// }

// export const widths = {
//   md: 720,
//   lg: 960,
//   xl: 1140
// }

// export const dimensions = {
//   headingSizes: {
//     h1: 2.441,
//     h2: 1.953,
//     h3: 1.563,
//     h4: 1.25
//   },
//   lineHeight: {
//     regular: 1.45,
//     heading: 1.2
//   },
//   containerPadding: 1.5
// }

// export const heights = {
//   header: 60,
// }

// export const paddings = {
//   sides: 8,
//   top: 5,
// }
